import { Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import {
  AntragsbuchFilter,
  BusinessPlanGoalsFilter,
  DamageFilter,
  DateFilter,
  EmployeeFilter,
  FivGoalsFilter,
  IGoal,
  KbvFilter,
  LeadFilter,
  PolicyFilter,
  PolicyStatus,
  StatisticFilter,
  TaskFilterDto,
  TaskStatus,
} from 'admiral-core';

export const DEFAULT_BUSINESS_PLAN_ORDER = [
  'Gesamtbewertung',
  'Unfall Bew o. Anp. Digi',
  'P-Sach o.Kr./U BZUW-BT',
  'Fonds Bewertung',
  'VAG:Leben KnP Bew',
  'VAG:Rente/Leben BewoZE',
  'P-Sach o.K/U Bew. Digi',
  'Bausparen Bewertung',
  'KH-PkW LfNST Digi',
  'Bausparen Neustück',
  'Kranken Zusatz Bew',
  'VAG: Leben KnP_PfEK-V NSt',
  'F-Sach o. Kraft Bew',
];
export const DEFAULT_HESS_ORDER = [
  'EH Gesamtbewertung',
  'Gesamtbewertung',
  'Sach Bewertung o. U-Anp.',
  'P-Sach Bew. Digi',
  'Leben Bewertung ohne ZE',
  'Kranken Bew o. Dyn.',
];
export const DEFAULT_RING_ORDER = [
  'EH Gesamtbewertung',
  'GP EH Sach Bewertung',
  'Unfall Bew o. Anp. Digi',
  'P-Sach o.K/U Bew. Digi',
  'KH-PkW LfNST Digi',
  'F-Sach o. Kraft Bew',
  'VAG:Rente/Leben BewoZE',
  'VAG:Leben KnP Bew',
  'Fonds Bewertung',
  'Kranken Bew o. Dyn.',
];
export const DEFAULT_FALL_ADS_ORDER = [
  'VAG: Leben KnP Bew',
  'Kranken Bew o. Dyn.',
  'nfall Bew o.Anp. Digi HW',
  'Fonds Bew+FRVZ+AKD',
];

export const DEFAULT_MY_BUSINESS_PLAN_PLUS_ORDER = [
  'KH-PkW LfNST o. Digi',
  'P-Schutz NSt o. Digi',
  'Leben PnGR Bew',
  'Leben KnP/R BEWoZE',
  'KV-Pflege-LFNST-EA',
  'KH-PkW u P-Sch. NSt Digi',
];
export const DEFAULT_MY_WINNERS_CLUB_ORDER = [
  'Gesamtbewertung',
  'P-Sach o. K/U LfNST Digi',
  'Unfall NvP Digi',
  'KH-PkW LfNST Digi',
  'Leben Bew o. ZE',
  'Leben KnP Bew o. ZE',
  'Fonds Bewertung',
  'Kranken NVP Zählstück',
];
export const DEFAULT_MY_FALL_ADS_ORDER = [
  'VAG: Leben KnP Bew',
  'Kranken Bew o. Dyn.',
  'nfall Bew o.Anp. Digi HW',
  'Fonds Bew+FRVZ+AKD',
];

export enum PreferencesAction {
  blur = 'blur',
  setShowDemo = 'setShowDemo',
  collapseMenu = 'collapseMenu',
  collapseMenuSetting = 'collapseMenuSetting',

  expandMobileMenu = 'expandMobileMenu',
  setEmployeeFilter = 'setEmployeeFilter',
  setLeadFilter = 'setLeadFilter',
  setPolicyFilter = 'setPolicyFilter',

  setAntragsbuchFilter = 'setAntragsbuchFilter',
  setStatisticFilter = 'setStatisticFilter',
  setTaskFilter = 'setTaskFilter',
  setTask2Filter = 'setTask2Filter',
  setKbvFilter = 'setKbvFilter',
  setFivGoalsFilter = 'setFivGoalsFilter',
  setDamageFilter = 'setDamageFilter',
  setDamageView = 'setDamageView',
  setTaskView = 'setTaskView',

  setBusinessPlanGoalsFilter = 'setBusinessPlanGoalsFilter',
  setBusinessPlanPlusGoalsFilter = 'setBusinessPlanPlusGoalsFilter',
  setCompetitionsWinnersClubGoalsFilter = 'setCompetitionsWinnersClubGoalsFilter',

  updateBusinessPlanGoalOrder = 'updateBusinessPlanGoalOrder',
  updateCompetitionsRingGoalOrder = 'updateCompetitionsRingGoalOrder',
  updateCompetitionsHessClubGoalOrder = 'updateCompetitionsHessClubGoalOrder',
  updateCompetitionsFallAdsGoalOrder = 'updateCompetitionsFallAdsGoalOrder',

  updateMyBusinessPlanPlusGoalOrder = 'updateMyBusinessPlanPlusGoalOrder',
  updateCompetitionsMyWinnersClubGoalOrder = 'updateCompetitionsMyWinnersClubGoalOrder',
  updateCompetitionsMyFallAdsGoalOrder = 'updateCompetitionsMyFallAdsGoalOrder',

  updateKbvBusinessPlanPlusGoalOrder = 'updateKbvBusinessPlanPlusGoalOrder',
  updateCompetitionsKbvWinnersClubGoalOrder = 'updateCompetitionsKbvWinnersClubGoalOrder',
  updateCompetitionsKbvFallAdsGoalOrder = 'updateCompetitionsKbvFallAdsGoalOrder',

  updateCustomGoalOrder = 'updateCustomGoalOrder',

  updateDarkMode = 'updateDarkMode',
  updateFirstVisit = 'updateFirstVisit',
  updateFirstVisitAfterV12 = 'updateFirstVisitAfterV12',
  updateAdminMode = 'updateAdminMode',

  resetPolicyFilter = 'resetPolicyFilter',
  resetAntragsbuchFilter = 'resetAntragsbuchFilter',
  resetStatisticFilter = 'resetStatisticFilter',
  resetDamageFilter = 'resetDamageFilter',

  setPoliciesColumns = 'setPoliciesColumns',
  setAntragsbuchColumns = 'setAntragsbuchColumns',
  resetTaskFilter = 'resetTaskFilter',

  reloadPage = 'reloadPage',
}

export interface Tour {
  [key: string]: Date | undefined;
}

export interface PreferencesState {
  blurred: boolean;
  showDemo: boolean;
  menuCollapsed: boolean;
  menuCollapsedSetting: boolean;
  darkMode: boolean;
  adminMode: boolean;
  firstVisitAt: Date;
  firstVisitAfterV12: Date;
  lastReload: Date;
  tour: Record<string, Tour>;

  mobileMenuExpanded: boolean;
  employeeFilter: EmployeeFilter;
  leadFilter: LeadFilter;
  policyFilter: PolicyFilter;
  taskFilter: TaskFilterDto;
  /** Persisted filters for tasks2 (`/tasks2`) — independent of header `taskFilter` (legacy tasks). */
  task2Filter: TaskFilterDto;
  fivGoalsFilter: FivGoalsFilter;

  antragsbuchFilter: AntragsbuchFilter;
  statisticFilter: StatisticFilter;
  damageFilter: DamageFilter;
  damageView: 'list' | 'kanban';
  taskView: 'list' | 'kanban' | 'calendar';

  businessPlanGoalsFilter: BusinessPlanGoalsFilter;
  businessPlanPlusGoalsFilter: BusinessPlanGoalsFilter;

  businessPlanGoalsOrder: string[];
  competitionsRingGoalsOrder: string[];
  competitionsHessClubGoalsOrder: string[];

  kbvBusinessPlanPlusGoalsOrder: string[];
  kbvCompetitionsWinnersClubGoalsOrder: string[];
  kbvCompetitionsFallAdsGoalsOrder: string[];

  myBusinessPlanPlusGoalsOrder: string[];
  myCompetitionsWinnersClubGoalsOrder: string[];
  myCompetitionsFallAdsGoalsOrder: string[];

  customGoalsOrder: string[];

  policiesColumns: string[];
  antragsbuchColumns: string[];
}

@Module({ namespaced: true, name: 'PreferencesModule' })
export class PreferencesModule extends VuexModule<PreferencesState> {
  blurred = false;
  showDemo = false;
  menuCollapsed = false;
  menuCollapsedSetting = false;
  darkMode = false;
  adminMode = false;

  mobileMenuExpanded = false;
  firstVisitAt: Date | null = null;
  firstVisitAfterV12: Date | null = null;
  lastReload: Date | null = null;

  tour: Record<string, Tour> = {
    onboarding: {},
  };

  employeeFilter: EmployeeFilter = {};
  leadFilter: LeadFilter = {};
  policyFilter: PolicyFilter = {
    dateFilter: DateFilter.ALL,
    businessYear: new Date().getFullYear(),
    products: [],
    users: [],
    status: [],
  };

  antragsbuchFilter: AntragsbuchFilter = {
    dateFilter: DateFilter.ALL,
    products: [],
    users: [],
    status: [PolicyStatus.POLICED],
  };

  statisticFilter: StatisticFilter = {
    dateFilter: DateFilter.ALL,
    products: [],
    users: [],
    status: [],
  };

  kbvFilter: KbvFilter = {
    users: [],
  };

  taskFilter: TaskFilterDto = {
    status: [TaskStatus.TODO],
    dateFilter: DateFilter.ALL,
    users: [],
  };

  task2Filter: TaskFilterDto = {
    status: [
      TaskStatus.TODO,
      TaskStatus.IN_PROGRESS,
      TaskStatus.IN_WAITING,
      TaskStatus.COMPLETED,
      TaskStatus.ARCHIVED,
    ],
    dateFilter: DateFilter.ALL,
    users: [],
  };

  fivGoalsFilter: FivGoalsFilter = {
    year: new Date().getFullYear(),
  };

  damageFilter: DamageFilter = {
    dateFilter: DateFilter.ALL,
    products: [],
    users: [],
    tags: [],
    important: undefined,
  };

  damageView: 'list' | 'kanban' = 'list';
  taskView: 'list' | 'kanban' = 'list';

  businessPlanGoalsOrder: string[] = DEFAULT_BUSINESS_PLAN_ORDER;

  competitionsRingGoalsOrder: string[] = DEFAULT_RING_ORDER;
  competitionsHessClubGoalsOrder: string[] = DEFAULT_HESS_ORDER;

  myBusinessPlanPlusGoalsOrder: string[] = DEFAULT_MY_BUSINESS_PLAN_PLUS_ORDER;
  myCompetitionsWinnersClubGoalsOrder: string[] = DEFAULT_MY_WINNERS_CLUB_ORDER;
  myCompetitionsFallAdsGoalsOrder: string[] = DEFAULT_MY_FALL_ADS_ORDER;

  policiesColumns: string[] = [
    'updatedAt',
    'status',
    'tasks',
    'customer',
    'product',
    'tags',
    'user',
    'value',
    'quantity',
    'probability',
    'type',
  ];

  antragsbuchColumns: string[] = [
    'tasks',
    'customer',
    'product',
    'tags',
    'user',
    'value',
    'quantity',
    'type',
    'antragsbuchData.submittedAt',
    'antragsbuchData.isArchived',
    'antragsbuchData.policyStartAt',
    'antragsbuchData.policyEndAt',
    'antragsbuchData.vnr',
    'antragsbuchData.bonus',
    'antragsbuchData.kvmob',
    'antragsbuchData.lvbsu',
  ];

  get isBlurred(): boolean {
    return this.blurred;
  }

  get getShowDemo(): boolean {
    return this.showDemo;
  }

  get isMenuCollapsed(): boolean {
    return this.menuCollapsed;
  }

  get isMenuCollapsedSetting(): boolean {
    return this.menuCollapsedSetting;
  }

  get isMobileMenuExpanded(): boolean {
    return this.mobileMenuExpanded;
  }

  get getEmployeeFilter(): EmployeeFilter {
    return this.employeeFilter;
  }

  get getLeadFilter(): LeadFilter {
    return this.leadFilter;
  }

  get isDarkMode(): boolean {
    return this.darkMode;
  }

  get getPolicyFilter(): PolicyFilter {
    return this.policyFilter;
  }

  get getAntragsbuchFilter(): AntragsbuchFilter {
    return this.antragsbuchFilter;
  }

  get getStatisticFilter(): StatisticFilter {
    return this.statisticFilter;
  }

  get getFivGoalsFilter(): FivGoalsFilter {
    return this.fivGoalsFilter;
  }

  get getKbvFilter(): PolicyFilter {
    return this.kbvFilter;
  }

  get getTaskFilter(): TaskFilterDto {
    return this.taskFilter;
  }

  get getTask2Filter(): TaskFilterDto {
    return this.task2Filter;
  }

  get getDamageFilter(): DamageFilter {
    return this.damageFilter;
  }

  get getDamageView(): 'list' | 'kanban' {
    return this.damageView;
  }

  get getTaskView(): 'list' | 'kanban' | 'calendar' {
    return this.taskView;
  }

  get getFirstVisitAt(): Date | null {
    return this.firstVisitAt;
  }
  get getFirstVisitAfterV12(): Date | null {
    return this.firstVisitAfterV12;
  }

  get getBusinessPlanGoalsOrder(): string[] {
    return this.businessPlanGoalsOrder;
  }

  get getMyBusinessPlanPlusGoalsOrder(): string[] {
    return this.myBusinessPlanPlusGoalsOrder;
  }

  get getCompetitionsRingGoalsOrder(): string[] {
    return this.competitionsRingGoalsOrder;
  }
  get getCompetitionsHessClubGoalsOrder(): string[] {
    return this.competitionsHessClubGoalsOrder;
  }

  get getMyCompetitionsWinnersClubGoalsOrder(): string[] {
    return this.myCompetitionsWinnersClubGoalsOrder;
  }
  get getMyCompetitionsFallAdsGoalsOrder(): string[] {
    return this.myCompetitionsFallAdsGoalsOrder;
  }

  get getBusinessPlanPlusGoalsOrder(): string[] {
    return this.myBusinessPlanPlusGoalsOrder;
  }

  get getPoliciesColumns(): string[] {
    return this.policiesColumns;
  }

  get getAntragsbuchColumns(): string[] {
    return this.antragsbuchColumns;
  }

  get isAdminMode(): boolean {
    return this.adminMode;
  }

  @MutationAction({ mutate: ['menuCollapsed'], rawError: true })
  async [PreferencesAction.collapseMenu](collapse: boolean) {
    return { menuCollapsed: collapse };
  }
  @MutationAction({ mutate: ['menuCollapsedSetting'], rawError: true })
  async [PreferencesAction.collapseMenuSetting](collapse: boolean) {
    return { menuCollapsedSetting: collapse };
  }

  @MutationAction({ mutate: ['blurred'], rawError: true })
  async [PreferencesAction.blur](blur: boolean) {
    return { blurred: blur };
  }

  @MutationAction({ mutate: ['showDemo'], rawError: true })
  async [PreferencesAction.setShowDemo](showDemo: boolean) {
    return { showDemo };
  }

  @MutationAction({ mutate: ['mobileMenuExpanded'], rawError: true })
  async [PreferencesAction.expandMobileMenu](expand: boolean) {
    return { mobileMenuExpanded: expand };
  }

  @MutationAction({ mutate: ['employeeFilter'], rawError: true })
  async [PreferencesAction.setEmployeeFilter](employeeFilter: EmployeeFilter) {
    return { employeeFilter };
  }

  @MutationAction({ mutate: ['leadFilter'], rawError: true })
  async [PreferencesAction.setLeadFilter](leadFilter: LeadFilter) {
    return { leadFilter: { ...leadFilter } };
  }

  @MutationAction({ mutate: ['policyFilter'], rawError: true })
  async [PreferencesAction.setPolicyFilter](policyFilter: PolicyFilter) {
    return { policyFilter: { ...policyFilter } };
  }

  @MutationAction({ mutate: ['antragsbuchFilter'], rawError: true })
  async [PreferencesAction.setAntragsbuchFilter](antragsbuchFilter: AntragsbuchFilter) {
    return { antragsbuchFilter: { ...antragsbuchFilter } };
  }

  @MutationAction({ mutate: ['statisticFilter'], rawError: true })
  async [PreferencesAction.setStatisticFilter](statisticFilter: StatisticFilter) {
    return { statisticFilter: { ...statisticFilter } };
  }

  @MutationAction({ mutate: ['fivGoalsFilter'], rawError: true })
  async [PreferencesAction.setFivGoalsFilter](fivGoalsFilter: FivGoalsFilter) {
    return { fivGoalsFilter: { ...fivGoalsFilter } };
  }

  @MutationAction({ mutate: ['kbvFilter'], rawError: true })
  async [PreferencesAction.setKbvFilter](kbvFilter: KbvFilter) {
    return { kbvFilter: { ...kbvFilter } };
  }
  @MutationAction({ mutate: ['taskFilter'], rawError: true })
  async [PreferencesAction.setTaskFilter](taskFilter: TaskFilterDto) {
    return { taskFilter: { ...taskFilter } };
  }

  @MutationAction({ mutate: ['task2Filter'], rawError: true })
  async [PreferencesAction.setTask2Filter](task2Filter: TaskFilterDto) {
    return { task2Filter: { ...task2Filter } };
  }

  @MutationAction({ mutate: ['damageFilter'], rawError: true })
  async [PreferencesAction.setDamageFilter](damageFilter: DamageFilter) {
    return { damageFilter: { ...damageFilter } };
  }

  @MutationAction({ mutate: ['damageView'], rawError: true })
  async [PreferencesAction.setDamageView](damageView: 'list' | 'kanban') {
    return { damageView };
  }

  @MutationAction({ mutate: ['taskView'], rawError: true })
  async [PreferencesAction.setTaskView](taskView: 'list' | 'kanban' | 'calendar') {
    return { taskView };
  }

  @MutationAction({ mutate: ['policyFilter'], rawError: true })
  async [PreferencesAction.resetPolicyFilter]() {
    return {
      policyFilter: {
        agency: undefined,
        dateFilter: DateFilter.ALL,
        products: [],
        users: [],
        status: [],
      },
    };
  }

  @MutationAction({ mutate: ['antragsbuchFilter'], rawError: true })
  async [PreferencesAction.resetAntragsbuchFilter]() {
    return {
      antragsbuchFilter: {
        agency: undefined,
        dateFilter: DateFilter.ALL,
        products: [],
        users: [],
        status: [PolicyStatus.POLICED],
      },
    };
  }

  @MutationAction({ mutate: ['statisticFilter'], rawError: true })
  async [PreferencesAction.resetStatisticFilter]() {
    return {
      statisticFilter: {
        agency: undefined,
        dateFilter: DateFilter.ALL,
        products: [],
        users: [],
        status: [],
      },
    };
  }

  @MutationAction({ mutate: ['damageFilter'], rawError: true })
  async [PreferencesAction.resetDamageFilter]() {
    return {
      damageFilter: {
        agency: undefined,
        dateFilter: DateFilter.ALL,
        products: [],
        users: [],
        tags: [],
        important: undefined,
      },
    };
  }

  @MutationAction({ mutate: ['businessPlanGoalsOrder'], rawError: true })
  async [PreferencesAction.updateBusinessPlanGoalOrder](businessPlanGoals: IGoal[]) {
    return { businessPlanGoalsOrder: businessPlanGoals.map((goal: IGoal) => goal.name) };
  }

  @MutationAction({ mutate: ['myBusinessPlanPlusGoalsOrder'], rawError: true })
  async [PreferencesAction.updateMyBusinessPlanPlusGoalOrder](businessPlanGoals: IGoal[]) {
    return { myBusinessPlanPlusGoalsOrder: businessPlanGoals.map((goal: IGoal) => goal.name) };
  }

  @MutationAction({ mutate: ['darkMode'], rawError: true })
  async [PreferencesAction.updateDarkMode](value: boolean) {
    return { darkMode: value };
  }

  @Mutation
  updateOrder(businessPlanGoals: IGoal[]) {
    this.businessPlanGoalsOrder = businessPlanGoals.map((goal: IGoal) => goal.name);
  }

  @Mutation
  updateRingCompetitionOrder(ringCompetitionGoals: IGoal[]) {
    this.competitionsRingGoalsOrder = ringCompetitionGoals.map((goal: IGoal) => goal.name);
  }

  @Mutation
  updateHessClubCompetitionOrder(hessClubCompetitionGoals: IGoal[]) {
    this.competitionsHessClubGoalsOrder = hessClubCompetitionGoals.map((goal: IGoal) => goal.name);
  }

  @Mutation
  updateWinnersClubCompetitionOrder(winnersClubCompetitionGoals: IGoal[]) {
    this.myCompetitionsWinnersClubGoalsOrder = winnersClubCompetitionGoals.map(
      (goal: IGoal) => goal.name,
    );
  }

  @Mutation
  updateMyFallAdsCompetitionOrder(goals: IGoal[]) {
    this.myCompetitionsFallAdsGoalsOrder = goals.map((goal: IGoal) => goal.name);
  }

  @MutationAction({ mutate: ['firstVisitAt'], rawError: true })
  async [PreferencesAction.updateFirstVisit]() {
    return { firstVisitAt: new Date() };
  }

  @MutationAction({ mutate: ['firstVisitAfterV12'], rawError: true })
  async [PreferencesAction.updateFirstVisitAfterV12]() {
    return { firstVisitAfterV12: new Date() };
  }

  @MutationAction({ mutate: ['lastReload'], rawError: true })
  async [PreferencesAction.reloadPage]() {
    return { lastReload: new Date() };
  }

  @Mutation
  updatePoliciesColumns(columns: string[]) {
    this.policiesColumns = columns;
  }

  @Mutation
  updateAntragsbuchColumns(columns: string[]) {
    this.antragsbuchColumns = columns;
  }

  @MutationAction({ mutate: ['adminMode'], rawError: true })
  async [PreferencesAction.updateAdminMode](isAdminMode: boolean) {
    return { adminMode: isAdminMode };
  }
}
